<mat-dialog-actions class="justify-content-between">
    <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.WARD' | translate }}</h3>
    <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.WARD' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="wardForm">
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.WARD' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'ENTITY.WARD' | translate }}" formControlName="name" appCapitalizeFirstLetter>
                    <mat-error *ngIf="wardForm.get('name')?.hasError('required') && 
                    (wardForm.get('name')?.dirty || wardForm.get('name')?.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="wardForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM50' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.CODE' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.CODE' | translate }}" formControlName="code">
                    <mat-error *ngIf="wardForm.get('code')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM_20' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-label><strong>{{'LABEL.IS_ACTIVE' | translate }}:</strong></mat-label>
                 &nbsp;&nbsp;&nbsp;&nbsp;
                <mat-checkbox class="example-margin" color="primary" formControlName="isActive"></mat-checkbox>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row m-t-4 p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button type="button" class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' |
                translate
                }}</button>

            <button mat-flat-button type="button" color="primary" class=" m-l-4" (click)="onUpdateWard()" *ngIf="isEdit"
                [disabled]="wardForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            <button mat-flat-button type="button" color="primary" class=" m-l-4" (click)="onAddWard()" *ngIf="!isEdit"
                [disabled]="wardForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>